<template>
  <notification-card
    :variation="cardVariant"
    :title="title"
    :icon-class="iconClass"
    :icon="icon"
    :iso-timestamp="n['@timestamp']">
    <template #menu>
      <NotificationMenu :n="n" :variant="menuVariant" />
    </template>
    <template v-if="attCount > 0" #attachments_menu>
      <AttachmentsMenu :n="n" />
    </template>
    <template v-if="attCount > 0" #attachments>
      <AttachmentsViewer :n="n" />
    </template>
    <b-tag v-if="n.metaData['package-name']" class="mb-2" size="is-medium" :type="tagClass">{{ n.metaData['package-name'] }}</b-tag>

    <p v-if="typeof content === 'object' && content.safeHtml != null" v-html="content.safeHtml"/>
    <p v-else v-text="content"/>

  </notification-card>
</template>

<script>
import { styleOptionByType } from './mobile-fallback'
import attachments from '@/services/attachments'
import { pascalToHuman } from '@/services/text/humanify'
import { marked } from 'marked'
export default {
  props: {
    n: Object
  },
  computed: {
    meta () { return this.n.metaData },
    content () {
      const res = styleOptionByType(this.n, 'content', 'content')
      if (typeof(res) === 'object' && res.text) return res.text // literal result
      if (typeof(res) === 'object' && res.mrkdwn) return { safeHtml: marked(res.mrkdwn) } // literal result
      return this.meta[res] // property name
    },
    title () {
      const res = styleOptionByType(this.n, 'title', 'policy-set-rule')
      if (typeof(res) === 'object' && res.text) return res.text // literal result
      return pascalToHuman(this.meta[res]) // property name
    },
    iconClass () { return styleOptionByType(this.n, 'iconClass') },
    icon () { return styleOptionByType(this.n, 'icon') },
    menuVariant () { return styleOptionByType(this.n, 'menuVariant') },
    tagClass () { return styleOptionByType(this.n, 'tagClass', 'is-info') },
    cardVariant () { return styleOptionByType(this.n, 'cardVariant') },
    attCount () { return attachments.parse(this.n).all.length },
  }
}
</script>